import Header from "./Header";
import Footer from "./Footer";
import {Outlet} from "react-router-dom";

const Layout = () => {
    return(
        <div className="app">
            <Header></Header>

            <div className="content">
                <Outlet />
            </div>

            <div className="footer container">
                <Footer/>
            </div>

        </div>
    )
}

export default Layout;